import type { ReactNode } from 'react'
import { StepRowBadge } from '../../shared/steps/StepsToRebalanceAccordionBody'

const PLACEHOLDER_IMPORTANT_NOTE =
  'Some content to come here some content to come here some content to come here some content to come here some content to come here some content to come here'

enum IdealPlanImportantNoteState {
  NONE = 'NONE',
  PLACEHOLDER = 'PLACEHOLDER'
}

/** Change this to preview a different important-note state on the ideal plan sheet. */
const IDEAL_PLAN_IMPORTANT_NOTE_PREVIEW_STATE: IdealPlanImportantNoteState = IdealPlanImportantNoteState.NONE

export function IdealPlanImportantNote() {
  const importantNoteState = IDEAL_PLAN_IMPORTANT_NOTE_PREVIEW_STATE

  if (importantNoteState === IdealPlanImportantNoteState.NONE) {
    return null
  }

  return (
    <div className="px-5 pt-6">
      <IdealPlanImportantNoteCard>
        {importantNoteState === IdealPlanImportantNoteState.PLACEHOLDER ? (
          <IdealPlanImportantNotePointer index={1} text={PLACEHOLDER_IMPORTANT_NOTE} />
        ) : null}
      </IdealPlanImportantNoteCard>
    </div>
  )
}

export function IdealPlanImportantNoteCard({ children }: { children: ReactNode }) {
  return (
    <div
      className="relative flex flex-col gap-4 rounded-xl border border-[#F0F4F7] bg-white bg-no-repeat bg-right-top px-4 pb-6 pt-5"
      style={{ backgroundImage: "url('/images/bg-cover-curves.png')" }}
    >
      <div className="text-[13px] font-[500] leading-[130%] text-[#3D3D3D]">Important Note</div>
      {children}
    </div>
  )
}

type IdealPlanImportantNotePointerProps = {
  index: number
  text: string
}

export function IdealPlanImportantNotePointer({ index, text }: IdealPlanImportantNotePointerProps) {
  if (text.length === 0) {
    return null
  }

  return (
    <div className="flex items-start gap-4">
      <div className="flex h-7 w-7 shrink-0 items-center justify-center">
        <StepRowBadge index={index} />
      </div>
      <div className="pt-1 text-[13px] font-[400] leading-[150%] text-[#3D3D3D]">{text}</div>
    </div>
  )
}
